enum TemplateStyleVariant {
  CASUAL
  PROFESSIONAL
  URGENT
}

enum TemplateType {
  NETWORK_PRIVACY_NOTICE
  CLIENT_PORTAL_IDD
  ORGANISATION_PRIVACY_NOTICE
  IDD
  VERBAL_IDD
  WELCOME_EMAIL
  INVALID_TEMPLATE_NAME
  ESIS
  COMPLIANCE_NOTIFICATION_EMAIL
  OFFER_LETTER
  SUITABILITY_REPORT
  PROTECTION_SUITABILITY_REPORT
  VERBAL_SUITABILITY_REPORT
  LENDER_CONSENT_AGREEMENT
  JOINT_LIABILITY_AGREEMENT
  LENDER_REFERENCE_LETTER
  CLIENT_EMAIL
  SCHEDULING_EMAIL
  FACT_FIND
  PROTECTION_ADVICE_DISCLAIMER
  PROTECTION_ADVICE_DISCLAIMER_EMAIL
  CASE_REFERRAL_NOTIFICATION_EMAIL
  PROTECTION_ADDENDUM_LETTER
  PROTECTION_MANUAL_ADDENDUM_LETTER
  BUSINESS_PROTECTION_SUITABILITY_REPORT
}

enum TemplateRenderType {
  INVALID_EXPORT_TYPE
  EXPORT_TYPE_HTML
  EXPORT_TYPE_PDF
  EXPORT_TYPE_EMAIL
}

type Template {
  id: ID!
  allow_child_access: Boolean
  date_stored: String
  enforce_for_representative: Boolean
  file_type: FileType
  friendly_name: String
  is_confidential: Boolean
  name: TemplateType
  organisation: Organisation
  render_to: TemplateRenderType
  required_cases: Int
  required_clients: Int
  required_mortgages: Int
  required_organisations: Int
  required_products: Int
  required_users: Int
  styles: [TemplateStyleVariant!]
  default_style: TemplateStyleVariant
  sub_type: String
  template: String
  template_signature: String
  updated_by: User
  owning_organisation_id: String
}

type EmailTemplate {
  document: DocumentEntity!
  subject: String
  client_recipient_ids: [String!]!
}

input TemplateInput {
  allow_child_access: Boolean
  case_ids: [String!]
  client_ids: [String!]
  mortgage_ids: [String!]
  organisation_id: String
  organisation_ids: [String!]
  preview: Boolean
  product_ids: [String!]
  rendered_compliance_email_flag_type: CaseDetailsFlagFlagType
  return_signature: Boolean
  store_document: Boolean
  sub_type: String
  template_id: String
  template_name: TemplateType!
  user_ids: [String!]
}

input OrganisationTemplateInput {
  name: TemplateType!
  template: String!
  render_to: TemplateRenderType
  file_type: FileType
  allow_child_access: Boolean
  enforce_for_representative: Boolean
  date_stored: String
}

input EmailTemplateInput {
  template: TemplateInput!
  subject: String!
  client_recipient_ids: [String!]!
}
